<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :setLoading="setLoading"
    :localDataGrid="false"
    :backButtonRoute="backButtonRoute"
    ref="sundry-payment"
    :data-model="dataModel"
    :backRouteAppend="undefined"
    :isLoaded="loaded"
    :getHeaderToolbar="getHeaderToolbar"
  />
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import { mapGetters } from "vuex";

import { SupplierService } from "../../_services/api/suppliers/supplier.service";
import { BankAccountsServices } from "../../_services/api/finance/bankAccounts";
import { CompanyService } from "../../_services/api/accounts/company.service";
import { getFactorByCode } from "../../_store/helpers";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      IsSettlementDateEnforced: undefined,
      CheckStockWriteOff: false,
      loaded: false,
      setLoading: false,

      dataModel: {
        Code: undefined,
        SupplierCode: undefined,
        SupplierName: undefined,
        Currency: undefined,
        AccountNo: undefined,
        Amount: undefined,
        BAS: undefined,
        PayeeName: undefined,
        GST_Amount: undefined,
        IsGSTReportable: false,
        DateIn: undefined,
        Status: undefined,
        BankAccountName: undefined,
        BankAccountCode: undefined,
        BSBNO: undefined,
        BankAccountNumber: undefined,
        BSBNOBankAccountCode: undefined,

        CurrencyCode: "FX",
      },
    };
  },

  async created() {},
  async mounted() {
    this.$store.dispatch("dataContext/setReviewDataSource", []);
    this.initialized();
  },
  beforeDestroy() {},

  computed: {
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    backButtonRoute() {
      return (
        "/bank-accounts-transaction/review/" + this.dataModel.BankAccountCode
      );
    },

    getScreenJson() {
      var screenJson = {
        title: "Sundry Payment",
        endpoint: this.isReviewMode()
          ? {
              primary: "SundryPayment",
              postProcess: this.sundryPaymentPostProcess,
            }
          : { primary: undefined },
        headerData: {
          headerToolbar: {
            screenName: "Sundry Payment",
            pdf: false,
            audit: false,
            status: true,
            notes: false,
            save: this.baseView.mode == "create",

            auditItems: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    dataField: "FormattedDateChanged",
                    label: { text: "Created By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {},
                  },
                  {
                    dataField: "FormattedDateChanged",
                    label: { text: "Changed By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {},
                  },
                ],
              },
            ],
          },
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 3,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "DateIn",
                      dataField: "DateIn",

                      label: {
                        text: "Date",
                      },
                    },
                    {
                      // screenField: "Supplier",
                      dataField: "SupplierName",
                      label: {
                        text: "Supplier",
                      },
                    },

                    {
                      dataField: "IsGSTReportable",

                      editorType: "dxCheckBox",
                      // dataField:
                      label: {
                        text: "BAS Reportable",
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "PayeeName",
                    },

                    {
                      itemType: "group",
                      caption: "",
                      colCount: 2,
                      items: [
                        {
                          screenField: "Currency",
                        },
                        {
                          screenField: "ExchangeRate",
                        },
                      ],
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  colCount: 2,
                  items: [
                    {
                      screenField: "FXAmount",
                      dataField: "FXAmount",
                      label: {
                        text: `Amount (${this.dataModel.CurrencyCode})`,
                      },
                    },

                    {
                      screenField: "TaxTotal",
                      dataField: "FXTaxAmount",

                      label: {
                        text: `Tax (${this.dataModel.CurrencyCode})`,
                      },
                    },
                    {
                      screenField: "FXAmount",
                      dataField: "IncTaxAmount",
                      label: {
                        text: `Amount (${this.getCurrencyCode})`,
                      },
                      visible:
                        this.getCurrencyCode != this.dataModel.CurrencyCode,
                    },

                    {
                      screenField: "TaxTotal",
                      dataField: "TaxAmount",

                      label: {
                        text: `Tax (${this.getCurrencyCode})`,
                      },
                      visible:
                        this.getCurrencyCode != this.dataModel.CurrencyCode,
                    },
                  ],
                },
              ],
            },
          ],
          title: {
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: this.baseView.mode == "create" ? undefined : "Code",
                text: "Sundry Payment ",
              },
              secondary: {
                dataField:
                  this.baseView.mode == "create"
                    ? "Customer"
                    : "BankAccountName",
                text: this.baseView.mode == "create" ? undefined : " from ",
              },
            },
            secondary: {
              dataField: "AccountNo",
              text: "",
            },
          },
        },
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "SundryPaymentDetail",
              filter: ["SundryPaymentCode eq " + this.baseView.id],
              serverPaging: true,
              allowGrouping: false,
              // expand: "SaleItem",
              postProcessCallback: this.CashReceiptDetailPostProcess,
            },
          },
          toolbar: {
            search: false,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
            review: false,
          },
          columns: [
            {
              screenField: "Account",
              label: "Account",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "AccountCode",
                  },
                ],
                secondary: [
                  {
                    dataField: "",
                  },
                ],
              },
            },
            {
              screenField: "Branch",
              label: "Branch",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "BranchName",
                  },
                ],
                secondary: [
                  {
                    dataField: "BranchCode",
                  },
                ],
              },
            },
            {
              screenField: "Division",
              label: "Division",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "DivisionName",
                  },
                ],
                secondary: [
                  {
                    dataField: "DivisionCode",
                  },
                ],
              },
            },
            {
              screenField: "Comments",
              label: "Comment",
              dataField: "Comment",
            },
            {
              screenField: "FXAmount",
              label: `Amount (${this.dataModel.CurrencyCode})`,
              dataField: "FXAmount",
              visible: this.getCurrencyCode != this.dataModel.CurrencyCode,
            },
            {
              screenField: "FXAmount",
              label: "Amount (Base Currency)",
              dataField: "Amount",
            },
          ],

          valueChangedEventListners: [],
        },
        footerData: {
          footerItems: [
            {
              screenField: "FXTotal",
              location: "right",
              value: 0,
              dataField: "FXAmount",
              label: "Sub Total(" + this.dataModel.CurrencyCode + ")",
              customCalc: (headerData, gridItems) => {
                var total = 0;
                gridItems.forEach((element) => {
                  total = total + element.FXAmount;
                });

                return total;
              },
            },
            {
              screenField: "FXTotal",
              location: "right",
              label: "Tax(" + this.dataModel.CurrencyCode + ")",
              value: 0,
              allowEditing: false,
              customCalc: (headerData) => {
                return headerData.FXTaxAmount;
              },
            },
            {
              screenField: "FXTotal",
              location: "right",

              value: 0,
              customCalc: (headerData, gridItems) => {
                var total = 0;
                gridItems.forEach((element) => {
                  total = total + element.FXAmount;
                });
                var Balance = headerData.FXTaxAmount + total;

                return Balance;
              },

              label: "Total (" + this.dataModel.CurrencyCode + ")",
            },
            {
              screenField: "FXTotal",
              location: "right",

              value: 0,
              customCalc: (headerData, gridItems) => {
                var total = 0;
                gridItems.forEach((element) => {
                  total = total + element.Amount;
                });
                var Balance = headerData.TaxAmount + total;

                return Balance;
              },

              label: "Total (" + this.getCurrencyCode + ")",
              visible: this.getCurrencyCode != this.dataModel.CurrencyCode,
            },
          ],
        },
      };
      return screenJson;
    },
    getCurrencyCode() {
      if (this.dataModel.Currency) return this.dataModel.Currency;
      else return "";
    },

    getHeaderToolbar() {
      return {
        headerToolbar: {
          screenName: " ",
          pdf: false,
          audit: false,
          status: true,
          notes: false,
          save: false,
        },
      };
    },
  },
  methods: {
    isReviewMode() {
      return this.baseView.mode === "review";
    },
    async sundryPaymentPostProcess(data) {
      this.dataModel.Code = data.Code;
      this.dataModel.SupplierCode = data.SupplierCode;
      this.dataModel.IncTaxAmount = data.IncTaxAmount;
      this.dataModel.BAS = data.IsGSTReportable;
      this.dataModel.PayeeName = data.PayeeName;
      this.dataModel.GST_Amount = data.GSTAmount;
      this.dataModel.IsGSTReportable = data.IsGstReportable;
      this.dataModel.DateIn = data.DateIn;
      this.dataModel.Status = data.FriendlyStatus;
      this.dataModel.BankAccountCode = data.BankAccountCode;
      this.dataModel.AccountNo = data.BankAccountNo;

      this.dataModel.FXAmount = data.FXAmount;
      this.dataModel.FXTaxAmount = data.FXTaxAmount;
      this.dataModel.IncTaxAmount = data.IncTaxAmount;
      this.dataModel.TaxAmount = data.GSTAmount;
      this.dataModel.ExchangeRate = data.ExchangeRate;

      if (data.CurrencyCode) this.dataModel.CurrencyCode = data.CurrencyCode;

      await SupplierService.getByCode(this.dataModel.SupplierCode).then(
        async (response) => {
          if (response.data.value.length > 0) {
            this.dataModel.SupplierName = response.data.value[0].Name;
          }
        }
      );

      await CompanyService.getByCompanyCode(getFactorByCode(18).Factorc).then(
        (res) => {
          this.dataModel.Currency = res.data.value[0].CurrencyCode;
        }
      );

      await BankAccountsServices.getBankRecordByCode(data.BankAccountCode).then(
        async (response) => {
          if (response.data.value.length > 0) {
            this.dataModel.BankAccountName = response.data.value[0].AccountName;
            this.dataModel.BSBNO = response.data.value[0].BsbNo;
            this.dataModel.BankAccountNumber = response.data.value[0].AccountNo;
          }
        }
      );
      this.dataModel.BSBNOBankAccountCode =
        this.dataModel.BSBNO + " " + this.dataModel.BankAccountNumber;

      return data;
    },

    async initialized() {
      this.setLoading = true;

      this.loaded = true;
      await this.$store.dispatch("screenFactors/getFactors", [18]);
    },
  },
};
</script>
